import React from 'react'
import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material'
import { useUsLegRoleTypeLuts } from 'components/index'

interface LegRoleSelectProps {
  value: number | null
  onChange: (event: SelectChangeEvent<number>, child: React.ReactNode) => void
  disabled?: boolean
  label?: string
  roleId?: number[]
  allowNone?: boolean
}

export const LegRoleSelect: React.FC<LegRoleSelectProps> = ({
  value,
  onChange,
  disabled = false,
  label = 'Legislative Role',
  roleId,
  allowNone = false
}) => {
  const { lutValues: legRoleTypeLutValues, loading: loadingLegRoleTypeLutValues } = useUsLegRoleTypeLuts()
  const displayValue = value === 0 ? '' : value

  const filteredLegRoles = React.useMemo(() => {
    if (roleId == null) return [...legRoleTypeLutValues.legRoles].sort((a, b) => a.lutOrder - b.lutOrder)
    return [...legRoleTypeLutValues.legRoles]
      .filter(legRole => roleId.includes(legRole.role.id))
      .sort((a, b) => a.lutOrder - b.lutOrder)
  }, [legRoleTypeLutValues.legRoles, roleId])

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="legrole_id_label">{label}</InputLabel>
      <Select
        id="legrole_id"
        name="legRoleId"
        label={label}
        labelId="legrole_id_label"
        value={displayValue ?? ''}
        onChange={onChange}
        disabled={disabled || loadingLegRoleTypeLutValues}
      >
        {allowNone && (
          <MenuItem value="">None</MenuItem>
        )}
        {filteredLegRoles.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.descShort}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
